import {
  SkeletonText,
  Text,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import { useFetchDeveloperProfileQuery } from '@/apis/apps/slice'

const skeletonWrapper = css`
  margin-top: var(${SpacingToken.Spacing1});
`

type Props = {
  developerId: string
}

export const DeveloperDetails = ({ developerId }: Props) => {
  const { data: developerProfile, isLoading } =
    useFetchDeveloperProfileQuery(developerId)

  if (isLoading) {
    return (
      <div css={skeletonWrapper}>
        <SkeletonText width={70} height={14} animated />
      </div>
    )
  }

  return (
    <Text size="sm">
      by {developerProfile?.company || 'Text Certified Developer'}
    </Text>
  )
}
